'use client';

import { useEffect, useRef } from 'react';
import { mutate } from 'swr';
import { usePathname } from 'next/navigation';
import { useCurrentLocale } from '@locales/client';
import { useProfile } from '@/entities/profile/model/use-profile';
import {
  useUserLang,
  useIsAuth,
} from '@/shared/providers/user-provider/use-user';

const LocaleSync = () => {
  const isAuth = useIsAuth();
  const userLang = useUserLang();
  const locale = useCurrentLocale();
  const pathname = usePathname();
  const { trigger: updateProfile } = useProfile();
  const syncingLangRef = useRef<string | null>(null);

  useEffect(() => {
    if (userLang === syncingLangRef.current) syncingLangRef.current = null;

    if (!isAuth || !userLang || userLang === locale) return;
    if (syncingLangRef.current === locale) return;

    syncingLangRef.current = locale;

    const formData = new FormData();
    formData.append('lang', locale);

    const saveUserLanguage = async () => {
      try {
        await updateProfile(formData);
        await mutate('/profile/getProfileData');
        if (pathname.includes('/store')) {
          await mutate('/shop');
        }
      } catch (error) {
        syncingLangRef.current = null;
        console.error('Failed to update user language:', error);
      }
    };

    void saveUserLanguage();
  }, [isAuth, userLang, locale, pathname, updateProfile]);

  return null;
};

export { LocaleSync };
